var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_770_60220)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_770_60220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_770_60220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.730469 0H16.7305V16H0.730469V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_770_60220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8113 6.88H2.65125C2.03269 6.88 1.53125 7.38144 1.53125 8C1.53125 8.61856 2.03269 9.12 2.65125 9.12H14.8113C15.4298 9.12 15.9313 8.61856 15.9313 8C15.9313 7.38144 15.4298 6.88 14.8113 6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8113 2.08H2.65125C2.03269 2.08 1.53125 2.58144 1.53125 3.2C1.53125 3.81856 2.03269 4.32 2.65125 4.32H10.8113C11.4298 4.32 11.9313 3.81856 11.9313 3.2C11.9313 2.58144 11.4298 2.08 10.8113 2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8113 11.68H2.65125C2.03269 11.68 1.53125 12.1814 1.53125 12.8C1.53125 13.4186 2.03269 13.92 2.65125 13.92H10.8113C11.4298 13.92 11.9313 13.4186 11.9313 12.8C11.9313 12.1814 11.4298 11.68 10.8113 11.68Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_770_60220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.730469)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_770_60220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.730469)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.4e67af9d4c440f0051c403eb7d1ecd27.svg";
export { ForwardRef as ReactComponent };